import { GridCellProps } from '@progress/kendo-react-grid';
import { AdminProfileInfo } from 'app/components/AdminProfileInfo';

type Props = {
    className?: string;
    e: GridCellProps;
    onClick?: (e) => void;
    imageUrl?: string;
    teamName?: string;
};

const NameProfileCell = ({ className, e, onClick, imageUrl, teamName }: Props) => {
    const data = e.dataItem;
    return (
        <td className={className ?? ''}>
            <AdminProfileInfo
                src={data?.imageUrl ? data?.imageUrl : imageUrl ? imageUrl : ''}
                name={data.teamName ? data.teamName : teamName ? teamName : ""}
            />

        </td>
    );
};

export default NameProfileCell;
